export const RESIDENT_MEDICATIONS_QUERY_KEY = 'resident-medications'
export const RESIDENT_MEDICATIONS_URL =
  '/emar/medication-stock-records/overview'

export const STOCK_LOGS_QUERY_KEY = 'stock-records'
export const STOCK_LOGS_URL = '/emar/medication-stock-records/list'

export const STOCK_COUNT_URL = '/emar/medication-stock-records/stock-count'
export const DISPOSAL_URL = '/emar/medication-stock-records/waste'
